// extracted by mini-css-extract-plugin
export default {"menu":"VerticalMenu_menu__+lxwr","item":"VerticalMenu_item__3Smtq","dropdown":"VerticalMenu_dropdown__z+gd1","subMenu":"VerticalMenu_subMenu__MVsWr"};